// Tabel "Breakdown per Program Studi" Orientasi RS, dikelompokkan per jenjang.
// Angka dihitung SERVER (GET /orientasi-rs/dashboard-summary); di sini hanya menyusun
// kelompok. Peserta dikelompokkan menurut KATEGORI-nya (kolom spesialis/subspesialis/koas),
// jadi subjumlah kelompok selalu sama dengan kartu distribusi kategori.

export const KELOMPOK_JENJANG = [
    { kunci: "spesialis", judul: "Spesialis (Sp1)" },
    { kunci: "subspesialis", judul: "Subspesialis (Sp2)" },
    { kunci: "koas", judul: "Koas" },
];

const KOLOM = ["spesialis", "subspesialis", "koas", "total"];

export function kelompokkanBreakdown(rows) {
    return KELOMPOK_JENJANG.map(({ kunci, judul }) => {
        const prodi = (rows || [])
            .filter((r) => (r[kunci] || 0) > 0)
            .map((r) => ({ prodi_id: r.prodi_id, nama: r.nama_prodi, jumlah: r[kunci] }))
            .sort((a, b) => a.nama.localeCompare(b.nama, "id"));
        return { kunci, judul, subjumlah: prodi.reduce((n, p) => n + p.jumlah, 0), prodi };
    });
}

// Dipakai bila server (versi lama) belum mengirim `jumlah`.
export const jumlahDariBaris = (rows) =>
    KOLOM.reduce((acc, k) => ({ ...acc, [k]: (rows || []).reduce((n, r) => n + (r[k] || 0), 0) }), {});
